import { dataApiUrl } from 'utils/url';
import AuthAxios from 'utils/authAxios';

const DataApiUrl = dataApiUrl();

const RecoupAccounts = () => {
  const getById = (id, params = {}) =>
    AuthAxios.get(`${DataApiUrl}/admin/recoupAccounts/${id}`, { params })
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const getLedgers = (id, params = {}) =>
    AuthAxios.get(`${DataApiUrl}/admin/recoupAccounts/${id}/ledgers`, { params })
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const create = data =>
    AuthAxios.post(`${DataApiUrl}/admin/recoupAccounts/`, data)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const patch = (id, data) =>
    AuthAxios.patch(`${DataApiUrl}/admin/recoupAccounts/${id}`, data)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const getAllPayeeLabels = () =>
    AuthAxios.get(`${DataApiUrl}/admin/recoupAccounts/payeeLabels`)
      .then(res => res.data.data.results)
      .catch(err => {
        throw err.response;
      });

  return {
    getById,
    getLedgers,
    create,
    patch,
    getAllPayeeLabels,
  };
};

export default RecoupAccounts;
